import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "auto",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Logo Solana",
      fill: "url(#12)",
      "fill-rule": "evenodd",
      d: "M5.52 4.642a.645.645 0 0 1 .443-.184h15.322c.28 0 .42.339.222.537L18.48 8.03a.628.628 0 0 1-.444.184H2.715a.315.315 0 0 1-.222-.537l3.026-3.034Zm0 11.329a.627.627 0 0 1 .443-.184h15.322c.28 0 .42.339.222.537l-3.027 3.034a.627.627 0 0 1-.444.184H2.715a.315.315 0 0 1-.222-.537l3.026-3.034Zm12.516-5.885c.17 0 .329.068.444.184l3.027 3.034a.315.315 0 0 1-.222.537H5.963a.628.628 0 0 1-.444-.183l-3.026-3.035a.315.315 0 0 1 .222-.537h15.321Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "12",
        x1: "17.49",
        x2: "6.84",
        y1: "1.42",
        y2: "21.76",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#00FFA3" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#DC1FFF"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }